<template>
    <PickBackground objectKey="do_detail" type="delivery_order"/>
</template>

<script>
import PickBackground from '@/views/pick/Background.vue';

export default {
    components:{
        PickBackground
    },
}
</script>